if (!customElements.get('background-video')) {
    customElements.define('background-video',
    class BackgroundVideo extends HTMLElement {
      constructor() {
        super();
        this.mobileBreakpoint = 749;
        this.isMobile = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches;
        this.videoLoaded = false;
        this.handleMediaChange = this.handleMediaChange.bind(this);
        BackgroundVideo.intersectionObserver = BackgroundVideo.intersectionObserver || null;
      }

      connectedCallback() {
        this.desktopVideo = this.querySelector('[data-video]');
        this.mobileVideo = this.querySelector('[data-video-mobile]');
        this.hasMobileVideo = !!this.mobileVideo;

        this.mediaQuery = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`);
        this.mediaQuery.addEventListener('change', this.handleMediaChange);

        this.setupIntersectionObserver();
      }

      disconnectedCallback() {
        if (BackgroundVideo.intersectionObserver) {
          BackgroundVideo.intersectionObserver.unobserve(this);
        }
        if (this.mediaQuery) {
          this.mediaQuery.removeEventListener('change', this.handleMediaChange);
        }
      }

      setupIntersectionObserver() {
        if (!BackgroundVideo.intersectionObserver) {
          BackgroundVideo.intersectionObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const el = entry.target;
                if (entry.isIntersecting) {
                  if (!el.videoLoaded) {
                    el.loadVideo();
                  } else {
                    el.playVideo();
                  }
                } else if (el.videoLoaded) {
                  el.pauseVideo();
                }
              });
            },
            {
              rootMargin: '100px 0px',
              threshold: 0
            }
          );
        }

        BackgroundVideo.intersectionObserver.observe(this);
      }

      loadVideo() {
        if (this.videoLoaded) return;
        this.videoLoaded = true;

        const video = this.getCurrentVideo();
        if (!video) return;

        video.querySelectorAll('source').forEach((s) => { s.src = s.dataset.src });
        video.load();

        video.addEventListener('loadeddata', () => {
          this.handleVideoReady(video);
        }, { once: true });
      }

      getCurrentVideo() {
        this.isMobile = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches;
        return this.isMobile && this.hasMobileVideo ? this.mobileVideo : this.desktopVideo;
      }

      handleVideoReady(video) {
        const checkPlaying = () => {
          if (video.currentTime > 0.1) {
            video.classList.add('video--is-playing');
            video.removeEventListener('timeupdate', checkPlaying);
          }
        };
        video.addEventListener('timeupdate', checkPlaying);

        video.play().then(() => {
        }).catch((error) => {
          console.warn('Video autoplay prevented:', error);
        });
      }

      handleMediaChange(event) {
        this.isMobile = event.matches;
        this.loadVideo();
      }

      playVideo() {
        const video = this.getCurrentVideo();
        if (!video) return;
        video.play().catch(() => {});
      }

      pauseVideo() {
        const video = this.getCurrentVideo();
        if (!video) return;
        video.pause();
      }
    }
  )
}